import {
    Autocomplete,
    Dialog,
    FileCard,
    FileUploader,
    MimeType,
    Pane,
    TextareaField, TextInput,
    TextInputField,
    toaster
} from "evergreen-ui";
import React from "react";
import {findFirstByName} from "../../Constructor/common/matchMethods";
import {createNewMaterial} from "../Api";
import {useSelector} from "react-redux";
import {selectorStationsForFilters} from "../../Constructor/periodValuesFilterApi";

export default function UploadFileDialog({isShown, setIsShown, onCloseAction}) {

    const stations     = useSelector(selectorStationsForFilters);

    const acceptedMimeTypes = [MimeType.doc, MimeType.docx, MimeType.xls, MimeType.xlsx, MimeType.pdf, MimeType.rtf]

    const [fileName, setFileName] = React.useState("")
    const [station, setStation] = React.useState("")
    const [year, setYear] = React.useState("")
    const [notesForNewMaterial, setNotesForNewMaterial] = React.useState("")
    const [file, setFile] = React.useState([])

    const [fileRejections, setFileRejections] = React.useState([])
    const handleChange = React.useCallback((files) => {
        setFile([files[0]])
        setFileName(files[0].name.replace(/\.[^/.]+$/, ""))
    }, [])
    const handleRejected = React.useCallback((fileRejections) => setFileRejections([fileRejections[0]]), [])
    const handleRemove = React.useCallback(() => {
        setFile([])
        setFileRejections([])
    }, [])

    function isYearInvalid() {
        return year > 2100 || year < 1990
    }

    function getValidationMessage() {
        if (year.length === 0)
            return undefined

        if (isYearInvalid())
            return "Поле заполнено неверно. Год должен состоять из 4 цифр и быть между 1990 и 2100 годами."
    }

    function isUploadDisabled() {
        return fileName.trim().length === 0 || station.trim().length === 0 || year.trim().length === 0 ||
            file == null || fileRejections.length > 0 || file.length === 0 || isYearInvalid()
    }

    function clearDownloadDialog() {
        setFileName('')
        setStation('')
        setYear('')
        setNotesForNewMaterial('')
        setFile(null)
    }

    function getErrorMessage(file) {
        if (!acceptedMimeTypes.includes(file.type)) {
            return "Данный формат файла не поддерживается. Доступна загрузка файлов следующего формата: doc, docx, xls, " +
                "xlsx, pdf, rtf";
        }

        if (file.size > (process.env.REACT_APP_MATERIALS_FILE_SIZE_MB * 1024 ** 2)) {
            return "Размер загружаемого файла не должен превышать " + process.env.REACT_APP_MATERIALS_FILE_SIZE_MB + "Мб."
        }
    }

    function onUploadButton() {
        let res = findFirstByName(stations, station)

        createNewMaterial(fileName, res.id, file[0], year, notesForNewMaterial).then(
            res => {
                toaster.success("Файл был успешно загружен!")
                onCloseAction()
            }
        ).catch(() => toaster.danger("Ошибка!"))
    }

    return (
        <Dialog
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEscapePress={false}
            width={500}
            isShown={isShown}
            onCancel={() => {
                clearDownloadDialog()
                setIsShown(false)
            }}
            isConfirmDisabled={isUploadDisabled()}
            onConfirm={() => {
                onUploadButton()
                clearDownloadDialog()
                setIsShown(false)
            }}
            title="Загрузка файла"
            cancelLabel="Отмена"
            confirmLabel="Сохранить"
        >
            <Pane >
                <TextInputField
                    description="Наименование файла*"
                    marginBottom={4}
                    value={fileName}
                    onChange={e => setFileName(e.target.value)}
                />

                <Autocomplete
                    onSelect={selectedItem => setStation(selectedItem)}
                    value={station}
                    items={stations.map((station) => station.name)}
                >
                    {props => {
                        const { getInputProps, getRef, inputValue } = props
                        return (
                            <TextInputField
                                width={"100%"}
                                description="Название станции*"
                                marginBottom={4}
                                value={inputValue}
                                ref={getRef}
                                {...getInputProps()}
                            />
                        )
                    }}
                </Autocomplete>

                <TextInputField
                    type={"number"}
                    isInvalid={isYearInvalid() && (year.length !== 0)}
                    validationMessage={getValidationMessage()}
                    min={"1990"}
                    max={"2100"}
                    maxLength={4}
                    description={"Год*"}
                    value={year}
                    marginBottom={4}
                    onChange={e => setYear(e.target.value)}
                />

                <TextareaField
                    value={notesForNewMaterial}
                    onChange={(e) => setNotesForNewMaterial(e.target.value)}
                    description="Заметки"
                    marginBottom={4}
                    placeholder="Введите заметки о загружаемой версии"
                />

                <FileUploader
                    acceptedMimeTypes={acceptedMimeTypes}
                    label="Загрузите файл"
                    description={"Вы можете загрузить только 1 файл размером не более " + process.env.REACT_APP_MATERIALS_FILE_SIZE_MB + "Мб. "}
                    maxSizeInBytes={process.env.REACT_APP_MATERIALS_FILE_SIZE_MB * 1024 ** 2}
                    maxFiles={1}
                    onChange={handleChange}
                    onRejected={handleRejected}
                    renderFile={(file) => {
                        const { name, size, type } = file
                        const fileRejection = fileRejections.find((fileRejection) => fileRejection.file === file)
                        const { message } = fileRejection || {}
                        return (
                            <FileCard
                                key={name}
                                isInvalid={fileRejection != null}
                                name={name}
                                description={"загруженный файл"}
                                onRemove={handleRemove}
                                sizeInBytes={size}
                                type={type}
                                validationMessage={message === undefined ? "" : getErrorMessage(file)}
                            />
                        )
                    }}
                    values={file}
                />
            </Pane>
        </Dialog>
    );
}